let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gVfRD")).then(() => parcelRequire('96otq'));